module.exports = __webpack_public_path__ + "static/img/a030.fdca717.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a030.jpg
// module id = WOZu
// module chunks = 0